import { useTranslation } from 'react-i18next';
import { getAccessToken } from 'helpers/auth';
import { useUpdateMyLocalePreference } from 'hooks/useUpdateMyLocalePreference';
import * as Sentry from '@sentry/react';
import { formatLanguageLabel, supportedLanguageOptions } from '@sz/l10n';
import { LANGUAGE_LOCAL_STORAGE_KEY } from '../LocalizationWrapper/LocalizationWrapper';
import styles from './LanguagePicker.module.scss';
import { getSupportedLocaleFromLanguageCode } from '@/helpers/locales';

export function LanguagePicker() {
  const { t, i18n } = useTranslation();
  const { updateMyLocalePreference } = useUpdateMyLocalePreference();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const language = event.target.value;

    localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, language);
    i18n.changeLanguage(language);

    if (getAccessToken()) {
      const locale = getSupportedLocaleFromLanguageCode(language);
      if (locale) {
        updateMyLocalePreference(locale).catch(error =>
          Sentry.captureException(error)
        );
      }
    }
  };

  const currentShort = (i18n.language || 'en').toUpperCase();

  return (
    <div className={styles.container}>
      <span className={styles.label}>{currentShort} ▾</span>
      <select
        className={styles.select}
        value={i18n.language}
        onChange={handleChange}
        aria-label={t('common.selectLanguage')}
      >
        {supportedLanguageOptions.map(lang => (
          <option key={lang.value} value={lang.value}>
            {formatLanguageLabel(lang.locale)}
          </option>
        ))}
      </select>
    </div>
  );
}
